import { createBrowserRouter } from 'react-router-dom';

import { getArchitectureStatus } from '../../application/use-cases/GetArchitectureStatus';
import { getBuildInfo } from '../../infrastructure/platform/getBuildInfo';
import { createDependencies } from '../config/createDependencies';
import { createRoutes } from './routes';

export function createAppRouter() {
  const dependencies = createDependencies();

  const loadStatuses = async () => {
    const statuses = await getArchitectureStatus(dependencies);
    if (!import.meta.env.DEV) return statuses;

    const diagnostic = dependencies.dailyMissions.getRuntimeDiagnostic();
    return [
      ...statuses,
      { label: `secureContext: ${diagnostic.secureContext}`, available: diagnostic.secureContext },
      {
        label: `randomUUIDAvailable: ${diagnostic.randomUUIDAvailable}`,
        available: diagnostic.randomUUIDAvailable,
      },
      {
        label: `getRandomValuesAvailable: ${diagnostic.getRandomValuesAvailable}`,
        available: diagnostic.getRandomValuesAvailable,
      },
      {
        label: `indexedDbAvailable: ${diagnostic.indexedDbAvailable}`,
        available: diagnostic.indexedDbAvailable,
      },
      {
        label: `serviceWorkerAvailable: ${diagnostic.serviceWorkerAvailable}`,
        available: diagnostic.serviceWorkerAvailable,
      },
      {
        label: `databaseInitializationStatus: ${diagnostic.databaseInitializationStatus}`,
        available: diagnostic.databaseInitializationStatus === 'ready',
      },
    ];
  };

  return createBrowserRouter(
    createRoutes(loadStatuses, dependencies.dailyMissions, getBuildInfo()),
  );
}
